import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

// Goes to the previous page inside the app. If there is none (e.g. the user opened
// /login directly from a link), it goes to the Home page instead.
const BackButton = () => {
  const { t } = useLang();
  const navigate = useNavigate();

  const goBack = () => {
    if (window.history.state && window.history.state.idx > 0) navigate(-1);
    else navigate("/");
  };

  return (
    <button
      type="button"
      onClick={goBack}
      data-testid="auth-back-btn"
      className="flex items-center gap-1.5 text-sm font-medium text-[#14251F] mb-4 py-2 pr-3 hover:text-[#123A2C]"
    >
      <ArrowLeft className="w-4 h-4" /> {t("common.back")}
    </button>
  );
};

export default BackButton;
